<ng-progress/>
<div [attr.version]="version" [attr.lstUpd]="lstUpd">
  <router-outlet></router-outlet>
</div>
<router-outlet name="modal"></router-outlet>
